export enum EAlterationStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
}
